import { useCallback, useEffect, useState } from 'react';
import { getCurrentDateTime, request, toast } from '../../../../../../utils';
import { IconButton, Stack, Typography, TextField as MuiTextField } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Table } from '../../../../../../components';

const TABLE_HEADER = [
  { header: 'IPD No.', accessor: 'ipd_no' },
  { header: 'UHID No.', accessor: 'uhid' },
  { header: 'Bill No.', accessor: (row)=> row?.finalbill?.bill_no },
  { header: 'Patient Name', accessor: (row) => `${row.patient.first_name} ${row.patient.last_name}` },
  { header: 'Admission Date', accessor: (row) => `${getCurrentDateTime('date', row.admissionDate)}` },
  { header: 'Address', accessor: 'patient.address.address' },
  { header: 'Sponsor', accessor: 'patient.sponsor.name' },
  { header: 'Mobile No.', accessor: 'patient.address.mobile' }
];

const initialIndoorRegisterationDataObj = {
    data: [],
    loading: false
  };

export const IPDSearchHandlerAllBillManagement = ({ onClose, onAdd ,setSelectedRow}) => {
  const [input, setInput] = useState('');
  const [patientData, setPatientData] = useState(initialIndoorRegisterationDataObj);


  const getIPDSearchDetailList = useCallback(async () => {
    const lowercasedInput = input.toLowerCase().trim();
    const query = {};
    try {
        if (lowercasedInput) {
            query.patientName = lowercasedInput;
          }
      const response = await request('/indoor-registeration-all-detail-list', { method: 'GET', query : query});
      if (response?.success) {
        setPatientData(response?.data);
      } else {
        toast('Failed to load IPD registration list');
      }
    } catch (error) {
      toast('An error occurred while fetching the data');
    }
  }, []);

useEffect(()=>{
    getIPDSearchDetailList()
},[getIPDSearchDetailList])


useEffect(()=>{
    handlePatientData(input)
},[input])

  const handlePatientData = async() => {
    const lowercasedInput = input.toLowerCase().trim();
    try {
      const query = {};
      if (lowercasedInput) {
        query.patientName = lowercasedInput;
      }
      const response = await request('/indoor-registeration-all-detail-list', {
        method: 'GET',
        query: query
      });
      if (response.success) {
        setPatientData({ loading: false, data: response?.data });
      } else {
        toast('Error in fetching data', { variant: 'error' });
        setPatientData({ loading: false });
      }
    } catch (error) {
      console.error('Error during search:', error);
      toast('Error during search', { variant: 'error' });
      setPatientData({ loading: false, data: [] });
    }
  };
  const handleChange = (e) => {
    const newInput = e.target.value;
    setInput(newInput);
  };


  return (
    <>
      <Stack
        direction="row"
        spacing={2}
        alignItems="center"
        justifyContent="space-between"
        borderBottom="1px solid"
        borderColor="grey.300"
      >
        <Typography variant="h4" fontWeight="bold">
          Indoor Registeration Search
        </Typography>
        <IconButton onClick={onClose}>
          <CloseIcon color="error" fontSize="large" />
        </IconButton>
      </Stack>
      <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0 }}>
        <MuiTextField
          sx={{
            width: '100%',
              '& .MuiOutlinedInput-root': {
                padding: '0',
                fontSize: '1.4rem' // Adjust input font size
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 1.4rem'
              },
              '& .MuiInputLabel-root': {
                fontSize: '1.2rem' // Adjust label font size
              }
          }}
          label="Search Patient"
          variant="outlined"
          value={input}
          onChange={handleChange}
        />
      </Stack>
      <Table
        sx={{ mt: 0.5 }}
        columns={TABLE_HEADER}
        data={patientData?.data || []}
        onRowClick={(row) => {
          onAdd(row.ipd_no);
          onClose();
          setSelectedRow(true);
        }}
      />
    </>
  );
};
